module.exports = __webpack_public_path__ + "img/audi.ddc3b08d.jpeg";